(() => {
  'use strict';

  const media = {
    coaching: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-user-personal-training.jpg?v=1789665028',
    training: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-user-training-plans.jpg?v=1789665041',
    founder: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mj-paknahad-original-portrait.jpg?v=1789563788&width=1200',
    peptides: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-peptides-premium-20260917.png?v=1789667181'
  };

  const ownScript = document.currentScript || Array.from(document.scripts).find(script => script.src.includes('mbf-user-media-fix.js'));
  const heroVideoUrl = ownScript ? new URL('mbf-hero-user-video.mp4', ownScript.src).href : '';
  const ptVideoUrl = heroVideoUrl;
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const swap = (img, url) => {
    if (!img || img.dataset.mbfUserMedia === url) return;
    img.src = url;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.dataset.mbfUserMedia = url;
    img.style.objectFit = 'cover';
  };

  const ensureStyles = () => {
    if (document.getElementById('mbf-user-media-style')) return;
    const style = document.createElement('style');
    style.id = 'mbf-user-media-style';
    style.textContent = `
      .mh-hero{position:relative;isolation:isolate;min-height:clamp(620px,74vh,860px);display:flex;align-items:center;background:#09090b;overflow:hidden}
      .mh-hero__user-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:62% center;z-index:0;background:#09090b}
      .mh-hero__video-shade{position:absolute;inset:0;z-index:1;pointer-events:none;background:linear-gradient(90deg,rgba(5,5,7,.94) 0%,rgba(5,5,7,.76) 38%,rgba(5,5,7,.42) 68%,rgba(5,5,7,.26) 100%)}
      .mh-hero:after{z-index:2}.mh-hero .mh-hero__in{position:relative;z-index:3}
      .ptl-hero__visual{position:relative;overflow:hidden;background:#08090b}
      .ptl-hero__visual .mbf-user-pt-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center center;z-index:1;background:#08090b;border-radius:inherit}
      .ptl-hero__visual .ptl-hero__mark{position:absolute;z-index:3}
      .mbf-peptide-banner{background:#09090b;padding:0 0 clamp(34px,5vw,72px)}
      .mbf-peptide-banner__inner{max-width:1440px;margin:0 auto;padding:0 20px}
      .mbf-peptide-banner img{display:block;width:100%;height:auto;border-radius:20px;box-shadow:0 28px 80px rgba(0,0,0,.35);background:#09090b}
      @media(max-width:980px){.mh-hero__video-shade{background:linear-gradient(90deg,rgba(5,5,7,.92) 0%,rgba(5,5,7,.68) 55%,rgba(5,5,7,.38) 100%)}}
      @media(max-width:560px){
        .mh-hero{min-height:620px;padding:82px 0 70px}.mh-hero__user-video{object-position:58% center}.mh-hero__video-shade{background:linear-gradient(180deg,rgba(5,5,7,.50) 0%,rgba(5,5,7,.72) 40%,rgba(5,5,7,.94) 100%)}
        .ptl-hero__visual .mbf-user-pt-video{object-position:center center}
        .mbf-peptide-banner{padding-bottom:28px}.mbf-peptide-banner__inner{padding:0 12px}.mbf-peptide-banner img{border-radius:12px}
      }
    `;
    document.head.appendChild(style);
  };

  const configureVideo = (video, src, poster) => {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.tabIndex = -1;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    if (poster) video.poster = poster;
    let source = video.querySelector('source');
    if (!source) {
      source = document.createElement('source');
      video.appendChild(source);
    }
    if (source.src !== src) {
      source.src = src;
      source.type = 'video/mp4';
      video.load();
    }
    if (!reduceMotion) {
      video.autoplay = true;
      video.setAttribute('autoplay', '');
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    }
  };

  const ensureHeroVideo = () => {
    const hero = document.querySelector('.mh-hero');
    if (!hero || !heroVideoUrl) return;
    ensureStyles();
    let video = hero.querySelector('.mh-hero__user-video');
    if (!video) {
      video = document.createElement('video');
      video.className = 'mh-hero__user-video';
      hero.insertBefore(video, hero.firstChild);
    }
    configureVideo(video, heroVideoUrl, media.founder);
    if (!hero.querySelector('.mh-hero__video-shade')) {
      const shade = document.createElement('div');
      shade.className = 'mh-hero__video-shade';
      shade.setAttribute('aria-hidden', 'true');
      hero.insertBefore(shade, video.nextSibling);
    }
  };

  const ensurePersonalTrainingVideo = () => {
    const wrap = document.querySelector('.ptl-hero__visual');
    if (!wrap || !ptVideoUrl) return;
    ensureStyles();
    const oldPremiumVideo = wrap.querySelector('.mbf-coach-video');
    if (oldPremiumVideo) oldPremiumVideo.remove();
    let video = wrap.querySelector('.mbf-user-pt-video');
    if (!video) {
      video = document.createElement('video');
      video.className = 'mbf-user-pt-video';
      wrap.appendChild(video);
    }
    configureVideo(video, ptVideoUrl, media.coaching);
  };

  const ensurePeptideBanner = () => {
    const hero = document.querySelector('.pep-hero');
    if (!hero || document.querySelector('.mbf-peptide-banner')) return;
    ensureStyles();
    const section = document.createElement('section');
    section.className = 'mbf-peptide-banner';
    section.setAttribute('aria-label', 'MBF Peptides');
    const inner = document.createElement('div');
    inner.className = 'mbf-peptide-banner__inner';
    const img = document.createElement('img');
    img.src = media.peptides;
    img.alt = 'MBF Peptides — Research, Recovery, Performance';
    img.loading = 'eager';
    img.decoding = 'async';
    inner.appendChild(img);
    section.appendChild(inner);
    hero.insertAdjacentElement('afterend', section);
  };

  const apply = (root = document) => {
    root.querySelectorAll('img[src*="mj-paknahad-original-portrait.jpg"]').forEach(img => swap(img, media.founder));
    root.querySelectorAll('img[src*="mbf-home-personal-training-premium.webp"]').forEach(img => swap(img, media.coaching));
    root.querySelectorAll('img[src*="mbf-home-training-plans-premium.webp"]').forEach(img => swap(img, media.training));
    root.querySelectorAll('img[src*="mbf-home-peptides-premium.webp"],img[src*="mbf-peptides-laboratory.jpg"],img[src*="mbf-service-peptide"]').forEach(img => swap(img, media.peptides));
    root.querySelectorAll('.ptl-hero__visual img').forEach(img => swap(img, media.coaching));
    root.querySelectorAll('.mbf-story-grid article:nth-child(2) img').forEach(img => swap(img, media.coaching));
    root.querySelectorAll('.mbf-story-grid article:nth-child(3) img').forEach(img => swap(img, media.training));
    root.querySelectorAll('.ptl-service-card[href*="training-schema"] img').forEach(img => swap(img, media.training));
    root.querySelectorAll('.tp-grid article:first-child img').forEach(img => swap(img, media.training));
    ensureHeroVideo();
    ensurePersonalTrainingVideo();
    ensurePeptideBanner();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => apply(), { once: true });
  else apply();

  const observer = new MutationObserver(() => apply());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();